angular
  .module('contrast.factory.applications', [])
  .factory('ApplicationFactory', function ($http, $q, UserService) {
    return {
      getFiltersCatalogs: function () {
        return $http.get(
          UserService.buildAPIUrl('/applications/filters/listing')
        )
      },
      getFiltersByType: function (type, filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl(
              '/applications/filters/' + type + '/listing'
            ),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getApplicationsByFilter: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/applications/filter'),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getShortApplicationsByFilter: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/applications/filter/short'),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      //applications
      getApplications: function (
        expandValue,
        includeArchived,
        filterServers,
        filterTechs,
        includeMerged
      ) {
        return $http.get(UserService.buildAPIUrl('/applications'), {
          params: {
            expand: expandValue,
            includeArchived: includeArchived,
            filterServers: filterServers,
            filterTechs: filterTechs,
            includeMerged: includeMerged
          }
        })
      },
      getApplicationsQuickFilters: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/applications/filters/quick'),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      /**
       * @param {boolean} includeModules
       * @param languages
       */
      getApplicationBase: function (includeModules, languages) {
        return $http.get(UserService.buildAPIUrl('/applications'), {
          params: {
            base: true,
            includeModules: includeModules,
            languages: languages ? languages.join() : ''
          }
        })
      },
      //includeMerged, includeTrial
      getApplicationsName: function (data) {
        return $http.get(UserService.buildAPIUrl('/applications/name'), {
          params: data
        })
      },

      //groups
      getAppGroups: function () {
        return $http.get(UserService.buildAPIUrl('/applications/groups'))
      },
      updateAppGroup: function (data) {
        return $http.put(UserService.buildAPIUrl('/applications/groups'), data)
      },
      addNewGroup: function (data) {
        return $http.put(UserService.buildAPIUrl('/applications/groups'), data)
      },
      clearGroup: function (data) {
        return $http.put(UserService.buildAPIUrl('/applications/groups'), data)
      },

      getApplication: function (id, expandValue) {
        return $http.get(UserService.buildAPIUrl('/applications/' + id), {
          params: { expand: expandValue }
        })
      },
      getRoles: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/roles')
        )
      },

      //breakdown
      getTraceBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/breakdown/trace')
        )
      },
      getRuleBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/breakdown/rule')
        )
      },
      getCategoryBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/breakdown/category')
        )
      },
      getSeverityBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/breakdown/severity')
        )
      },
      getTraceStatusBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/breakdown/status')
        )
      },

      //libraries
      getLibraries: function (id, expandValue) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/libraries'),
          { params: { expand: expandValue } }
        )
      },
      getLibrariesStats: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/libraries/stats')
        )
      },

      //coverage
      getCoverage: function (id, searchKeywords, limit) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/coverage'),
          { params: { q: searchKeywords, limit: limit } }
        )
      },
      getLastWeekCoverageStats: function (id) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/coverage/stats/week'
          )
        )
      },

      //servers
      getServers: function (id, expandValue, includeMerged, onlyLicensed) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/servers'),
          {
            params: {
              expand: expandValue,
              includeMerged: includeMerged,
              onlyLicensed: onlyLicensed
            }
          }
        )
      },

      getAppServers: function (id) {
        return $http.get(
          UserService.buildAPIUrl(`/applications/${id}/servers/base`),
          {
            params: {}
          }
        )
      },

      getNewestServer: function (id, expandValue, includeMerged) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/servers/newest'),
          {
            params: {
              expand: expandValue,
              includeMerged: includeMerged
            }
          }
        )
      },
      getServerProtectionSettings: function (id, environment, includeMerged) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/servers/settings/environment'
          ),
          {
            params: {
              environment: environment,
              includeMerged: includeMerged
            }
          }
        )
      },
      getGeneralServerProtectionSettings: function (id, includeMerged) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/servers/settings'),
          {
            params: {
              includeMerged: includeMerged
            }
          }
        )
      },
      getServersBreakdown: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/servers/breakdown')
        )
      },

      //score trend
      getScoreTrend: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/history')
        )
      },

      //license
      getLicense: function (id) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + id + '/license')
        )
      },

      //app settings
      updateAppSettings: function (id, data) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + id + '/settings'),
          data
        )
      },

      //app actions
      archive: function (id) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + id + '/archive')
        )
      },
      archiveBatch: function (apps) {
        var self = this
        return self.batchExecution(apps, self.archive)
      },
      restore: function (id) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + id + '/restore')
        )
      },
      restoreBatch: function (apps) {
        var self = this
        return self.batchExecution(apps, self.restore)
      },
      reset: function (id) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + id + '/reset')
        )
      },
      resetBatch: function (apps) {
        var self = this
        return self.batchExecution(apps, self.reset)
      },
      deleteApp: function (id) {
        return $http['delete'](UserService.buildAPIUrl('/applications/' + id))
      },
      deleteBatch: function (apps) {
        var self = this
        return self.batchExecution(apps, self.deleteApp)
      },
      batchExecution: function (apps, method) {
        var deferred = $q.defer()
        var promises = []

        angular.forEach(apps, function (app) {
          var request = method(app.app_id)
          promises.push(request)
        })

        $q.all(promises).then(
          function (results) {
            deferred.resolve(results)
          },
          function (errors) {
            deferred.reject(errors)
          }
        )

        return deferred.promise
      },
      updateDisplayName: function (appId, displayName) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + appId + '/name/display'),
          { displayName: displayName }
        )
      },

      checkDisplayName: function (appId, data) {
        return $http.post(
          UserService.buildAPIUrl('/applications/' + appId + '/name/unique'),
          data
        )
      },

      getTechnologies: function (appId) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + appId + '/techs')
        )
      },
      getComponents: function (appId) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + appId + '/components')
        )
      },

      getApplicationAttacks: function (appId, params) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + appId + '/attacks'),
          {
            params: params
          }
        )
      },
      updateImportance: function (appId, data) {
        return $http.put(
          UserService.buildAPIUrl('/applications/' + appId + '/importance'),
          data
        )
      },

      getDefenseScore: function (appId) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + appId + '/scores/defense')
        )
      },
      countAllowedApps: function () {
        return $http.get(UserService.buildAPIUrl('/applications/allowed'))
      },

      //Application Exclusion
      getExclusions: function (appId) {
        return $http.get(
          UserService.buildAPIUrl('/applications/' + appId + '/exclusions')
        )
      },
      deleteExclusion: function (appId, exclusionId) {
        return $http['delete'](
          UserService.buildAPIUrl(
            '/applications/' + appId + '/exclusions/' + exclusionId
          )
        )
      },
      toggleAssessmentStatus: function (appId, exclusionId) {
        return $http.put(
          UserService.buildAPIUrl(
            '/applications/' +
              appId +
              '/exclusions/' +
              exclusionId +
              '/assessment'
          )
        )
      },
      countEventsByExclusion: function (appId, exclusionId) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/exclusions/' + exclusionId + '/events'
          )
        )
      },
      suppressEventsByExclusion: function (appId, exclusionId) {
        return $http.put(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/exclusions/' + exclusionId + '/events'
          )
        )
      },

      //Libraries
      getLibrariesScoreBreakdown: function (appId) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/libraries/breakdown/scores'
          )
        )
      },
      getLibrariesOutOfDate: function (appId) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + appId + '/libraries/breakdown/outofdate'
          )
        )
      },
      getAppLibrariesByFilter: function (data, appId) {
        var httpTimeout = $q.defer()
        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl(
            '/applications/' + appId + '/libraries/filter'
          ),
          params: data,
          timeout: httpTimeout.promise
        })
        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },
      getScore: function (appId) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl('/applications/' + appId + '/score'),
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      }
    }
  })
